"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("./common");
//Polyfill - IE can't post message to opener
var IEPolyfill = /** @class */ (function () {
    function IEPolyfill() {
        var _this = this;
        this.openPopupWithSameDomain = function (serviceType, environment, url) {
            if (url === void 0) { url = ''; }
            //for ie support, just open popup with self page
            return window.open(url + "?environment=" + environment + "&serviceType=" + serviceType + "&isSelfPopup=true", 'identityServicePopup', 'width=445, height=610, resizable=1, left=0, top=0');
        };
        this.appendIdentityServiceIframe = function () {
            try {
                var isFromIE = opener && opener.window.location.hostname === window.location.hostname;
                if (isFromIE) {
                    _this.makeBlankPage();
                    _this.appendIframe();
                    window.addEventListener('message', _this.receiveMessageFromIframe);
                }
            }
            catch (error) {
                /* eslint-disable no-console */
                console.log(error);
            }
        };
        this.makeBlankPage = function () {
            //remove dom and hide dom ==> make blank page
            document.body.innerHTML = document.body.innerHTML.replace(/(<div>|<\/div>)/gi, '');
            document.body.setAttribute('style', 'overflow:hidden');
            var style = document.createElement('style');
            style.innerHTML = 'body > *:not(#identityService) {display:none};';
            document.body.appendChild(style);
        };
        this.appendIframe = function () {
            var serviceUrl = common_1.identityServiceUrl(_this.getQueryParam('environment'), _this.getQueryParam('serviceType'));
            var iframeDom = document.createElement('div');
            iframeDom.setAttribute('id', 'identityService');
            var iframeStyle = "\n          position: fixed; z-index: 100;\n          left: 0; top:0; bottom:0; right:0; \n          width: 100%; height: 100%; \n          border: 0; background: #fff; overflow:hidden\n        ";
            iframeDom.innerHTML = "<iframe src='" + serviceUrl + "' style='" + iframeStyle + "' />";
            document.body.appendChild(iframeDom);
        };
        this.getQueryParam = function (name) {
            var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
            if (!results) {
                return null;
            }
            return decodeURI(results[1]) || 0;
        };
        this.getOrigin = function () {
            if (typeof window.location.origin === 'undefined') {
                return window.location.protocol + "//" + window.location.host;
            }
            return window.location.origin;
        };
        this.receiveMessageFromIframe = function (event) {
            if (typeof event.data.identityToken === 'undefined') {
                return;
            }
            if (window.opener) {
                window.opener.postMessage(event.data, _this.getOrigin());
            }
            window.removeEventListener('message', _this.receiveMessageFromIframe);
        };
    }
    return IEPolyfill;
}());
var iePolyfill = new IEPolyfill();
var openPopupWithSameDomain = iePolyfill.openPopupWithSameDomain;
exports.openPopupWithSameDomain = openPopupWithSameDomain;
var identityServiceInit = function () {
    iePolyfill.appendIdentityServiceIframe();
};
exports.identityServiceInit = identityServiceInit;
try {
    if (common_1.isIE() && iePolyfill.getQueryParam('isSelfPopup') === 'true') {
        identityServiceInit();
    }
}
catch (error) {
    console.warn(error);
}
//# sourceMappingURL=IEPolyfill.js.map